/*
	===========
	Contact Nav
	===========
*/
.contact-nav {
	display: none;
	justify-content: space-between;
	padding: 17px 16px;
	background-color: #DFD3E4;
	width: 100%;

	.contact-nav-left, .contact-nav-right {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.contact-nav-left {
		a {
			font-size: 16px;
			letter-spacing: .5px;
			line-height: 1.2;
			letter-spacing: 0.5px;
			text-decoration: none;
			color: $colour-black;
			margin-right: 16px;

			&:hover {
				text-decoration: underline;
			}

			&:last-of-type {
				margin-right: 0;
			}
		}
	}

    .contact-nav-right {
		p {
			font-weight: 500;
			font-size: 16px;
			line-height: 150%;
			letter-spacing: 1.25px;
			text-transform: capitalize;

			span {
				display: none;
			}
		}

        a {
            font-weight: 500;
            font-size: 16px;
            line-height: 120%;
            border: none;
            padding: 0;
			margin-top: 0 !important;
            margin-left: 16px;
            color: $colour-primary-500;
            background-color: transparent;
            text-decoration: underline;
            text-transform: capitalize;
            font-family: $font-header-bold;

			&:hover {
				text-decoration: none;
			}
        }
    }

	@include min(1024px) {
		display: flex;
		letter-spacing: 0.5px;

		.contact-nav-right {
			a {
				margin-left: 18px;
			}
		}
	}

	@include min(1200px) {
		.contact-nav-left a {
			font-size: 18px;
			margin-right: 24px;

			&:last-of-type {
				margin-right: 0;
			}
		}

		.contact-nav-right {
			p {
				font-size: 18px;
			}

			a {
				font-size: 20px;
				margin-left: 24px;
			}
		}
	}

	@include min(1360px) {
		padding: 17px 32px;
		.contact-nav-right {
			p {
				span {
					display: inline-block;
				}
			}
		}
	}
}
/* Contact Nav */


/*
	===========
	Main Nav
	===========
*/
.main-nav {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 14px 16px;
	position: fixed;
	top: 0;
	left: 0;
	background: white;
	width: 100%;
	z-index: 51;
	box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);

	.logo {
		.logo-desktop {
			display: none;
		}
        .logo-mobile {
            display: block;
        }
	}

	.main-nav-container {
		display: flex;
		justify-content: center;
		align-items: center;

		.navigation {
			display: none;

			a {
				font-size: 18px;
				line-height: 1.2;
				letter-spacing: 0.5px;
				text-decoration: none;
				color: $colour-black;
				padding: 10px 8px 6px;
				vertical-align: sub;
				flex-shrink: 0;

				&:hover {
					text-decoration: underline;
				}
			}
		}

		.main-nav-buttons {
			display: flex;
			align-items: center;
			flex-shrink: 0;

			.search-button {
				margin-right: 8px;
				padding: 0;
				border: none;
				background: transparent;
				cursor: pointer;
				flex-shrink: 0;
			}

			.btn-pair {
				display: none;

				.button, .button.secondary {
					flex-shrink: 0;
					padding-right: 8px;
					padding-left: 8px;
					margin-left: 0;
					font-size: 16px;
				}
			}
		}

		.contact-mobile-nav {
			display: flex;
			flex-direction: column;
			width: 100%;
			margin-top: 10px;
			padding-top: 30px;
			border-top: 1px solid $colour-input-border;
		}
	}

	.get-in-touch-btn-mobile {
		display: block;
		margin-right: 8px;
		padding-right: 8px;
		padding-left: 8px;
	}

	.menu-toggle-button {
		display: flex;
		padding: 0;
		border: none;
		background: transparent;

		.menu-btn-open {
			display: block;
		}
		.menu-btn-close {
			display: none;
		}
	}

	&.menu-open {
		.main-nav-container {
			.navigation {
				position: fixed;
				top: 72px;
				left: 0;
				flex-direction: column;
				display: flex;
				width: 100%;
				height: calc(100vh - 72px);
				z-index: 2;
				background-color: white;
				padding: 24px 24px 144px;
				overflow-x: hidden;
				overflow-y: auto;

				a {
					font-size: 20px;
					letter-spacing: -.25px;;
					line-height: 1.2;
					font-family: $font-header-bold;
					margin-bottom: 20px;
					padding: 0;
				}
			}

			.main-nav-buttons {
				.btn-pair {
					position: fixed;
					bottom: 0;
					left: 0;
					z-index: 2;
					display: flex;
					width: 100%;
					padding: 24px;
					flex-direction: row;
					flex-wrap: wrap;
					gap: 8px;
					background-color: white;

					.button, .button.secondary {
						padding-right: 18px;
						padding-left: 18px;
						font-size: 20px;
    					justify-content: center;
					}

					.button:first-of-type {
						width: 100%;
					}
					.button:not(:first-of-type) {
						width: calc(50% - 4px);
					}
				}
			}
		}

		.menu-toggle-button {
			.menu-btn-open {
				display: none;
			}
			.menu-btn-close {
				display: block;
			}
		}
	}

	@include min(380px) {
		.get-in-touch-btn-mobile {
			margin-right: 16px;
			padding-right: 18px;
			padding-left: 18px;
		}

		.main-nav-container {
			.main-nav-buttons {
				.search-button {
					margin-right: 16px;
				}
			}
		}
	}

	@include min(640px) {
		&.menu-open {
			.main-nav-container {
				.navigation {
					padding-bottom: 92px;
				}

				.main-nav-buttons {
					.btn-pair {
						flex-wrap: nowrap;

						.button, .button.secondary {
							flex: 1;
						}

						.button:first-of-type,
						.button:not(:first-of-type) {
							width: auto;
						}
					}
				}
			}
		}
	}

	@include min(1024px) {
		display: flex;
		letter-spacing: 0.5px;
		position: relative;
		top: initial;
		left: initial;

		.main-nav-container {
			.navigation {
				display: flex;
				flex-wrap: wrap;
				margin-left: 8px;
			}

			.main-nav-buttons {
				.search-button {
					margin-right: 16px;
					margin-left: 8px;
				}

				.btn-pair {
					display: inline-flex;
					column-gap: 16px;
				}
			}

			.contact-mobile-nav {
				display: none;
			}
		}

		.get-in-touch-btn-mobile {
			display: none;
		}

		.menu-toggle-button {
			display: none;
		}
	}

	@include min(1500px) {
		padding: 14px 32px;

		.logo {
			.logo-desktop {
				display: flex;
			}

			.logo-mobile {
				display: none;
			}
		}

		.main-nav-container {
			.navigation {
				margin-left: 0;
			}

			.main-nav-buttons {
				.search-button {
					margin-right: 16px;
				}

				.btn-pair {
					.button, .button.secondary {
						padding-right: 18px;
						padding-left: 18px;
						font-size: 20px;
					}
				}
			}
		}
	}
}
/* Main Nav */